import { render, staticRenderFns } from "./estimated-delivery.vue?vue&type=template&id=37532dd4&scoped=true&"
import script from "./estimated-delivery.vue?vue&type=script&lang=js&"
export * from "./estimated-delivery.vue?vue&type=script&lang=js&"
import style0 from "./estimated-delivery.vue?vue&type=style&index=0&id=37532dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37532dd4",
  null
  
)

export default component.exports